export default __webpack_public_path__ + "static/media/Esther_Stubbs_AHV_In_Moms_We_Trust.b32f733c.jpg";